// Configuration utilities for easy environment management

import { getEnvironmentConfig, getEnvironment, isDevelopment, isProduction } from './environment.config';

/**
 * Get OKTA configuration for the current environment
 */
export const getOktaConfig = () => {
  const config = getEnvironmentConfig();
  return {
    issuer: config.oktaIssuer,
    clientId: config.oktaClientId,
    redirectUri: config.oktaRedirectUri,
    postLogoutRedirectUri: config.oktaPostLogoutRedirectUri,
    scopes: config.oktaScopes,
  };
};

/**
 * Get API configuration for the current environment
 */
export const getApiConfig = () => {
  const config = getEnvironmentConfig();
  return {
    baseUrl: config.apiBaseUrl,
    timeout: isDevelopment() ? 30000 : 10000, // Longer timeout in dev for debugging
  };
};

/**
 * Get feature flags for the current environment
 */
export const getFeatureFlags = () => {
  return {
    enableDebugLogging: getEnvironmentConfig().enableDebugLogging,
    enableAnalytics: isProduction(),
    enableErrorReporting: !isDevelopment(),
  };
};

/**
 * Log configuration info (only in development)
 */
export const logConfigInfo = () => {
  if (isDevelopment()) {
    console.group('🔧 Application Configuration');
    console.log('Environment:', getEnvironment());
    console.log('OKTA Config:', getOktaConfig());
    console.log('API Config:', getApiConfig());
    console.log('Feature Flags:', getFeatureFlags());
    console.groupEnd();
  }
};

const configUtils = {
  getOktaConfig,
  getApiConfig,
  getFeatureFlags,
  logConfigInfo,
};

export default configUtils;